<!-- Problem Section -->
<section class="py-20 bg-gray-50 dark:bg-slate-900">
  <div class="max-w-7xl mx-auto px-4">
    <div class="text-center mb-16 scroll-fade-in">
      <h2 class="text-4xl font-bold text-gray-900 dark:text-white mb-4">Tu te reconnais ?</h2>
      <p class="text-xl text-gray-600 dark:text-gray-400">
        Tous les vendeurs ambulants vivent ces galères au quotidien
      </p>
    </div>

    <div class="grid md:grid-cols-3 gap-8">
      <div class="bg-white dark:bg-slate-800 rounded-xl p-8 shadow-lg dark:shadow-slate-900/50 card-hover scroll-fade-in">
        <div class="text-5xl mb-4">😰</div>
        <h3 class="text-xl font-bold text-gray-900 dark:text-white mb-3">
          Tu jettes chaque semaine
        </h3>
        <p class="text-gray-600 dark:text-gray-400">
          15 à 40% de pertes alimentaires par peur de manquer. Ça fait mal au
          cœur ET au portefeuille.
        </p>
      </div>

      <div class="bg-white dark:bg-slate-800 rounded-xl p-8 shadow-lg dark:shadow-slate-900/50 card-hover scroll-fade-in">
        <div class="text-5xl mb-4">🤦</div>
        <h3 class="text-xl font-bold text-gray-900 dark:text-white mb-3">
          Tu es déjà tombé en rupture
        </h3>
        <p class="text-gray-600 dark:text-gray-400">
          Des clients frustrés, des ventes perdues, une réputation entachée. Et
          tu ne sauras jamais combien tu as perdu.
        </p>
      </div>

      <div class="bg-white dark:bg-slate-800 rounded-xl p-8 shadow-lg dark:shadow-slate-900/50 card-hover scroll-fade-in">
        <div class="text-5xl mb-4">🤷</div>
        <h3 class="text-xl font-bold text-gray-900 dark:text-white mb-3">
          Tu décides à l'intuition
        </h3>
        <p class="text-gray-600 dark:text-gray-400">
          Excel basique, notes papier, mémoire approximative. Aucun historique
          exploitable pour t'améliorer.
        </p>
      </div>
    </div>
  </div>
</section>